export const SMALL_PADDING = 5;
export const LARGE_PADDING = 10;
